module.exports = __webpack_public_path__ + "img/stopList.b038c23b.png";